import * as FullStory from '@fullstory/browser';
import * as Sentry from '@sentry/browser';
import { ISelectOption } from '@whitelabel/helpers/types';
import { USER_CONTINENT, USER_COUNTRY } from './constants';
import { IError } from './types';

// Retry function to help reduce the frequency of chunk load issues occurring and the instances recorded in Sentry.
// eslint-disable-next-line import/prefer-default-export
export const retry = (fn: any, retriesLeft = 5, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: any) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export const getUserCountry = (): string => sessionStorage.getItem(USER_COUNTRY) || 'AU';

export const getUserContinent = (): string | null => sessionStorage.getItem(USER_CONTINENT);

export function captureExceptionWithFullyStory(error: IError, extra?: Record<string, any>): void {
  if (!window.isHeadless) {
    Sentry.setTag('FS Session', FullStory.getCurrentSessionURL(true));
    if (error.status) {
      Sentry.setTag('error_status', error.status);
    }
    if (error.code) {
      Sentry.setTag('error_code', error.code);
    }
  }
  Sentry.captureException(
    error,
    extra && {
      extra,
    },
  );
}

export const checkCurrency = (currencies: ISelectOption[], currency: string): string => {
  const formatCurrency = currency.toUpperCase().trim();
  const foundSupportCurrency = currencies.find((currencyList) => currencyList.value === formatCurrency);
  if (currency) {
    if (foundSupportCurrency) {
      return foundSupportCurrency.value!;
    }
  }
  return currencies[0].value!;
};

export const getCurrencySymbolOrName = (locale: string, currency: string, isSymbol = true): string =>
  (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency,
      currencyDisplay: isSymbol ? 'narrowSymbol' : 'name',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/[0-9\u0660-\u0669]/g, '')
    .trim();
